import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiFillTwitterCircle,
  AiFillInstagram,
  AiFillRedditCircle,
} from "react-icons/ai";
import { RiMessengerFill } from "react-icons/ri";
import { FaSnapchat, FaTwitch, FaTiktok } from "react-icons/fa";


function Footer() {
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3>Core elements by Soumyajit Behera. Designed by iklevente.</h3>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>All design images are generated by AI. The site was created with React.js.</h3>
        </Col>
        <Col md="4" className="footer-body">
          <ul className="footer-icons">
            <li className="social-icons">
              <a
                href="https://github.com/iklevente"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillGithub />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.instagram.com/iklevi.exe"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillInstagram />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://m.me/iklevente"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <RiMessengerFill />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://www.reddit.com/u/KAISTEP"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillRedditCircle />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitch.tv/levikek03"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaTwitch />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://twitter.com/iklevente"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <AiFillTwitterCircle />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://snapchat.com/add/iklevente"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaSnapchat />
              </a>
            </li>
            <li className="social-icons">
              <a
                href="https://tiktok.com/@iklevente"
                style={{ color: "white" }}
                target="_blank" 
                rel="noopener noreferrer"
              >
                <FaTiktok />
              </a>
            </li>
          </ul>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
